(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureDeleteController',PatientPictureDeleteController);

    PatientPictureDeleteController.$inject = ['$uibModalInstance', 'entity', 'PatientPicture'];

    function PatientPictureDeleteController($uibModalInstance, entity, PatientPicture) {
        var vm = this;

        vm.patientPicture = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PatientPicture.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
